import config from "../../app.json";
import axios from "axios";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FieldText from "../../Components/Fields/FieldText";
import { Row, Col, Button } from "react-bootstrap";

import AlertComponent from "../../Components/AlertComponent";
import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";

function RecoverPassword() {
  const [email, setEmail] = useState(null);

  let navigate = useNavigate();

  const handleSubmit = () => {
    axios
      .post(config.API + "/api/user/requestPasswordRecoveryCode", { email })
      .then(() => {
        navigate("/recoverPasswordCode", {
          state: { email: email },
          replace: false,
        });
      })
      .catch((error) => {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <div className="prelogin-container">
      <div className="containerLoginForm">
        <Row className="header-login">
          <Col className="col-md-6">
            <img className="cs-logo-login" src={CsWhiteLogo} />
          </Col>
          <Col className="col-md-6">
            <img className="aws-logo-login" src={AwsLogo} />
          </Col>
        </Row>
        <Row className="login-body">
          <Col className="col-md-7 cs-3d-phone">
            <iframe
              src="https://my.spline.design/untitled-c751e6b7fc77254e43fcafa257e796e6/"
              frameBorder="0"
              width="100%"
              height="100%"
            ></iframe>
          </Col>
          <Col className="col-md-5 cs-login-form">
            <h2>Recover Password</h2>
            <FieldText
              type="email"
              onChange={(x) => setEmail(x.target.value)}
              placeholder="Enter your email"
              label="Email"
              inputClassName="black-background-field"
              required={true}
              name={`email`}
              style={{width: "80%"}}
            />

            <div className="form-group mt-3 loginAlignCenter">
              <Button
                className="btn-sm submitLogin"
                onClick={handleSubmit}
              >
                Send code
              </Button>
            </div>

            <div className="loginAlignCenter">
              <span className="signUpText">
                Check your email and use the code on the next step.
              </span>
            </div>
            <div className="loginAlignCenter">
              <span className="signUpText">
                Already have an account?{" "}
                <a
                  className="signUpLink"
                  onClick={() => navigate("/login", { replace: false })}
                >
                  Sign In
                </a>
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default RecoverPassword;
